<template>
  <div class="orderWraper">
      <div class="type">
        <div class="item" @click="choseDay()" :class="{active: type == 1}">今日</div>
        <div class="item"><div @click="isMonthShow = !isMonthShow" :class="{active: type == 2}">{{ currentMonth + '月份'}} <img src="../assets/down.png" alt="下拉选择"></div>
          <div class="select" v-show="isMonthShow"> 
            <div v-for="i in 12" :key="i" class="s_item month" @click="choseMonth(i)"> {{i}}月 </div>
          </div>
        </div>
        <div class="item"><div @click="isSeasonShow = !isSeasonShow" :class="{active: type == 3}">{{currentSeason + '季度' }}<img src="../assets/down.png" alt="下拉选择"></div> 
          <div class="select" v-show="isSeasonShow">
            <div class="s_item season" v-for="i in 4" :key="i" @click="choseSeason(i)">{{i}}季度</div></div>
        </div>
        <div class="item"><div @click="isYearShow = !isYearShow" :class="{active: type == 4}"> {{currentYear ? currentYear : '年度'}} <img src="../assets/down.png" alt="下拉选择"></div>
          <div class="select" v-show="isYearShow">
            <div class="s_item year" v-for="i in year" :key="i" @click="choseYear(i)">{{i}}</div>
          </div>
        </div>
      </div>
      <div class="table">
        <div class="th">
          <div class="td" style="width: 40%">乡镇/街道</div>
          <div class="td" style="width: 15%">已{{orderType == 'xiu' ? '修' : '抽'}}</div>
          <div class="td" style="width: 15%">未{{orderType == 'xiu' ? '修' : '抽'}}</div>
          <div class="td" style="width: 30%">超两天未{{orderType == 'xiu' ? '修' : '抽'}}</div>
        </div> 
      </div>
      <div class="table tbodyWraper">            
          <div class="tbody" :style="'transform: translateY(' + top + 'px)'">
            <div class="tr" v-for="item in order" :key="item.id">
              <div class="td" style="width: 40%">{{item.name}}</div>
              <div class="td" style="width: 15%" v-if="orderType == 'xiu'">{{item.yixiu}}</div>
              <div class="td" style="width: 15%" v-if="orderType == 'chou'">{{item.yichou}}</div>
              <div class="td" style="width: 15%" v-if="orderType == 'xiu'">{{item.weixiu}}</div>
              <div class="td" style="width: 15%" v-if="orderType == 'chou'">{{item.weichou}}</div>
              <div class="td active" style="width: 30%">{{item.guoqi}}</div>
            </div>   
          </div>                         
      </div>     
  </div>
</template>

<script>
 const height = 35;
export default {
  props: ['orderType', 'order'],
  data() {
    return {
      year: [],
      currentMonth: '',
      currentSeason: '',
      currentYear: '',
      isMonthShow: false,
      isSeasonShow: false,
      isYearShow: false,
      type: 1,
      top: 0,    
      timer: '',
      showLines: 1,  
    }
  },
  watch: {
    order() {
      let i = 0;
      if(this.timer) {
        clearInterval(this.timer)
      }
      if(this.order.length > this.showLines) {  
        this.timer = setInterval(() => {
          i ++;
          this.top = 0 - i * height;
          if(i >= 13 - this.showLines) {
            i = 0;
          }
        }, 2500)
      }      
    }
  },
  methods: {
    setYear() {
      let currentYear = new Date().getFullYear();
      let beginYear = 2019;
      let years = [];
      while (beginYear <= currentYear) {
        years.push(beginYear);
        beginYear ++;       
      }
      this.year = years;
    },
    choseMonth(i) {
      this.type = 2;
      this.currentMonth = i;
      this.currentSeason = '';
      this.currentYear = '';
      this.isMonthShow = false;
      this.$emit('dateChange', this.orderType, this.type, i);
    },
    choseSeason(i) {
      this.type = 3;
      this.currentSeason = i;
      this.currentMonth = '';
      this.currentYear = '';
      this.isSeasonShow = false;
      this.$emit('dateChange',this.orderType, this.type, i);
    },
    choseYear(i) {
      this.type = 4;
      this.currentYear = i;
      this.currentMonth = '';
      this.currentSeason = '';
      this.isYearShow = false;
      this.$emit('dateChange', this.orderType, this.type, i);
    },        
    choseDay() {
      this.type = 1;
      this.$emit('dateChange', this.orderType, this.type);
    },
  },
  mounted() {
    this.setYear();
    let wraperHeight = document.getElementsByClassName('tbodyWraper')[0].clientHeight;      
    this.showLines = Math.ceil(wraperHeight / height);
    let i = 0;
    if(this.order.length > this.showLines) {  
      this.timer = setInterval(() => {
        i ++;
        this.top = 0 - i * height;
        if(i >= 13 - this.showLines) {
          i = 0;
        }
      }, 2500)
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  }
}
</script>

<style>
.orderWraper {
  height: calc(100% - 50px);
}
.orderWraper .tbodyWraper{
  height: calc(100% - 72px);
  overflow: hidden;
}
.orderWraper .tbody {
  transition: all .5s;
  /* height: calc(100% - 35px); */
  /* overflow: hidden; */
}
</style>